import { buildUrl } from 'commonUtils';

class UiExportApi {
  export(path = '', params = {}) {
    const url = buildUrl('/spr/uiExport', { path, ...params, _t: Date.now() });
    window.open(url, '_blank');
  }
}

export default UiExportApi;
